import { Component, Input, OnInit } from '@angular/core';
import { StepperReadyEvent, StepperService } from '@mydocma/import-export';
import { faultDuplicateStepperConfig } from './fault-duplicate-stepper.config';
import { BehaviorSubject } from 'rxjs';
import { AppContainerService } from '@mydocma/app-container';
import { ViewFault } from '@docma-mm-core/fault/fault';
import { FaultDuplicateWizardStepperService } from '../services/fault-duplicate-wizard-stepper.service';
import { Project } from '@docma-mm-core/project/project';
import { isIosDevice } from '@docma-mm-core/utils/utils';

@Component({
  selector: 'mydocma-mm-fault-duplicate-stepper',
  templateUrl: './fault-duplicate-stepper.component.html',
  styleUrls: ['./fault-duplicate-stepper.component.scss']
})
export class FaultDuplicateStepperComponent implements OnInit {

  @Input() fault: ViewFault;
  @Input() project: Project;

  private stepperServiceSubject = new BehaviorSubject<StepperService>(null);
  stepperService$ = this.stepperServiceSubject.asObservable();

  stepperConfig = faultDuplicateStepperConfig;

  private stepperService: StepperService;

  isMobileIOS = false;

  constructor(
    public appContainerService: AppContainerService,
    private stepperDataService: FaultDuplicateWizardStepperService
  ) { }

  ngOnInit() {
    this.isMobileIOS = this.appContainerService.isMobileView && isIosDevice();
  }

  onReadyEvent(event: StepperReadyEvent) {
    this.stepperService = event.stepperService;
    this.stepperServiceSubject.next(this.stepperService);
  }
}